const appConfig = {
    // apiPrefix: 'https://pickup-server-y10z.onrender.com',
    // apiPrefix: 'http://localhost:7000/',
    apiPrefix: 'https://webadmin.pickupkart.in/',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
}

export default appConfig


